// routes
import { PATH_DASHBOARD, PATH_REPORTS } from '../../routes/paths';
// components
import {
  HomeOutlined,
  AssessmentOutlined,
  HistoryOutlined
} from '@mui/icons-material';

const navConfig = [
  {
    subheader: '',
    items: [
      {
        title: 'Dashboard',
        path: PATH_DASHBOARD.general.app,
        icon: <HomeOutlined />
      }
    ]
  },
  {
    subheader: 'Reports',
    items: [
      {
        title: 'Generate Report',
        path: PATH_REPORTS.general.create,
        icon: <AssessmentOutlined />
      },
      {
        title: 'Historical Reports',
        path: PATH_REPORTS.general.history,
        icon: <HistoryOutlined />
      }
    ]
  },
];

export default navConfig;
